import * as ActionTypes from '../redux-actions/redux-actions';

const initalState = {
    error : null,
    token : null,
    userId : null,
    loading : false
}

const onAuthSuccess = (state , actions) => {
    return {
        loading : false,
        userId : actions.userId,
        token : actions.token,
    }
}

const onAuthError = (state , actions) => {
    return {
        loading : false,
        error : actions.error
    }
}

const removeError = (state, actions) => {
    return {
        error : null
    }
}

const AuthReducer = (state = initalState,actions) => {
    switch(actions.type){
        case ActionTypes.AUTH:
            return {error : null,loading : true}
        case ActionTypes.AUTH_SUCCESS:
            return onAuthSuccess(state , actions);
        case ActionTypes.AUTH_ERROR:
            return onAuthError(state, actions);
        case ActionTypes.REMOVE_ERROR:
            return removeError(state, actions);
        case ActionTypes.LOGOUT:
            return initalState;
        default:
            return state;
    }
}

export default AuthReducer;